<template>
  <!-- 弹窗 -->
  <Transition>
    <div class="pop-bg pass" v-show="props.passShow">
      <div class="pop-box">
		  <img src="../../assets/images/joinMaskTopImg.png" class="topImg pcImg" alt="" />
		  <img src="../../assets/images/joinMaskTopImg-m.png" class="topImg mImg" alt="" />
        <img src="../../assets/img/icons/icon-close.png" alt="" class="close" @click="emit('closeToast')">
		<h2>{{ $t("您的联系邮箱") }}</h2>
		<input type="text" class="email" v-model="email"  placeholder="请输入您的邮箱地址"/>
		<div class="next" @click="submit">{{ $t("提交") }}</div>
        <!-- <div class="amend binding-tel">
          <div class="code">
            <input v-model="email">
          </div>
          <div class="next" @click="submit">{{ $t("提交") }}</div>
        </div> -->
      </div>
    </div>
  </Transition>



</template>
<script setup>
import {getCurrentInstance, ref} from "vue";
import {ElMessage} from "element-plus";
import {joinYuzhen} from "@/api/register";
import {getLanguageValue} from "@/utils/language";
import {useI18n} from "vue-i18n";
// 多语言调用
const { appContext : { config: { globalProperties } } } = getCurrentInstance();
const { locale } = useI18n()
const passShow = ref(true)
const props = defineProps({
  passShow: { type: Boolean, default: false },
})
const emit = defineEmits();
const email = ref("")

function submit(){
  let reg = /^.+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;

  if (!reg.test(email.value)) {
    ElMessage({
      type: 'error',
      message: globalProperties.$t("邮箱格式错误"),
    })
    return
  }
  joinYuzhen(email.value,getLanguageValue(locale.value)).then(res => {
    ElMessage({
      type: 'success',
      message: globalProperties.$t("邮箱已提交，会有工作人员联系您"),
    })
    emit('closeToast')
    email.value = "";
  }).catch(err => {
    console.log(err)
  })
}



</script>
<style src="./joinTip.css" scoped>
</style>
